import moment from "moment";

const filterByAudience = (blogPost, state) => state.audiences.some(audience => audience.isActive) ?
    state.audiences.some(audience => audience.isActive && audience.id === blogPost.relationships.field_blog_audience.id) :
    blogPost;

const filterByTag = (blogPost, state) => state.tags.some(tag => tag.isActive) ?
    state.tags.some(stateTag => stateTag.isActive && blogPost.relationships.field_blog_tags.some(blogTag => blogTag.id === stateTag.id)) :
    blogPost;


const filterByStartDate = (blogPost, state) =>{
    const blogDate = moment.utc(blogPost.created);
    const startDate = state.startDate ? moment.utc(state.startDate) : null;
    return !startDate || startDate.isBefore(blogDate);

}

const filterByEndDate = (blogPost, state) => {
const blogDate = moment.utc(blogPost.created);
const endDate = state.endDate ? moment.utc(state.endDate) : null;
return !endDate || endDate.isAfter(blogDate);
}

const blogFilterCallbacks = [filterByAudience, filterByTag, filterByStartDate, filterByEndDate];

export default blogFilterCallbacks;
